// [Thai, English] copy for the UI-only MeERP screen shells.
const copy: Record<string, [string, string]> = {
  MEERP_SCREEN_ER00: ["ภาพรวมงาน", "Overview"],
  MEERP_SCREEN_MD01: ["ข้อมูลยาและผู้ขาย", "Medicine and vendors"],
  MEERP_SCREEN_PR01: ["รายการจัดซื้อ", "Procurement records"],
  MEERP_SCREEN_PR02: ["ใบขอซื้อและใบสั่งซื้อ", "Requests and purchase orders"],
  MEERP_SCREEN_GR01: ["PO รอรับยา", "POs awaiting receipt"],
  MEERP_SCREEN_GR02: ["บันทึกและยืนยันรับยา", "Record and confirm receipt"],
  MEERP_SCREEN_FN01: ["กฎภาษีผู้ขาย", "Vendor tax rules"],
  MEERP_SCREEN_FN02: ["สรุปซื้อรายบริษัท", "Purchases by vendor"],
  MEERP_SCREEN_FN03: ["ตรวจภาษีและยอดจ่าย", "Tax and net payment"],
  MEERP_SCREEN_FN04: ["อนุมัติจ่าย", "Payment approval"],
  MEERP_SCREEN_FN05: ["สมุดรายวันและบัญชีแยกประเภท", "Journal and ledger"],
  MEERP_SCREEN_FN06: ["ผังบัญชีและ mapping", "Chart of accounts and mapping"],
  MEERP_SCREEN_FN07: ["นำส่งข้อมูลการรักษา", "Treatment accounting feed"],
  MEERP_SCREEN_RP01: ["รายงานและประวัติเอกสาร", "Reports and document history"],
  MEERP_GROUP_PROCUREMENT: ["จัดซื้อและรับยา", "Procurement and receiving"],
  MEERP_GROUP_FINANCE: ["บัญชีและการเงิน", "Accounting and finance"],
  MEERP_SCAFFOLD_BADGE: ["โครงหน้า — ยังไม่เปิดทำรายการ", "Screen shell — actions unavailable"],
  MEERP_SCAFFOLD_NOTICE: ["หน้านี้เป็นโครง UI ตาม TOR ยังไม่ดึงข้อมูลจริง ไม่บันทึก ไม่คำนวณ และไม่พิมพ์เอกสาร", "This TOR-based screen shell does not fetch live data, save, calculate, or print documents."],
  MEERP_DEPENDENCY_LABEL: ["รอก่อนเปิดใช้:", "Required before activation:"],
  MEERP_WORKFLOW_LABEL: ["ลำดับใช้งานที่ออกแบบ", "Planned workflow"],
  MEERP_VIEW_LABEL: ["มุมมอง", "View"],
  MEERP_FILTERS_LABEL: ["ตัวกรอง", "Filters"],
  MEERP_DETAILS_LABEL: ["ข้อมูลในหน้า", "Screen fields"],
  MEERP_LIST_PREVIEW_LABEL: ["โครงตารางรายการ", "Record table layout"],
  MEERP_ACTIONS_LABEL: ["ปุ่มตาม workflow — ยังไม่เปิดใช้", "Workflow actions — unavailable"],
  MEERP_AWAITING_DATA: ["รอข้อมูล API — ไม่ใช่ยอดศูนย์", "Awaiting API data — not zero"],
  MEERP_VIEW_NEXT_SCAFFOLD: ["ดูโครงหน้าถัดไป", "View next screen shell"],
  MEERP_OVERVIEW_UNAVAILABLE: ["ยังไม่ดึงยอด", "Not loaded"],
  MEERP_OVERVIEW_NOTE: ["การ์ดงานยังไม่แสดงตัวเลขจนกว่าจะมี API และเงื่อนไขสถานะที่ทดสอบแล้ว", "Work cards show no counts until APIs and status rules are verified."],
  MEERP_OVERVIEW_PENDING_PO: ["PO รอรับยา", "POs awaiting receipt"],
  MEERP_OVERVIEW_PENDING_GR: ["ใบรับยารอตรวจ", "Receipts awaiting review"],
  MEERP_OVERVIEW_PENDING_PAYMENT: ["ชุดจ่ายรออนุมัติ", "Payments awaiting approval"],
  MEERP_OVERVIEW_FEED_ERROR: ["นำส่งบัญชีผิดพลาด", "Accounting feed errors"],
  MEERP_DEP_PRODUCT_STOCK: ["Product/Stock API เดิมและสัญญาราคา/ผู้ขาย", "Existing Product/Stock APIs and price/vendor contracts"],
  MEERP_DEP_PUR_WRITE_PRINT: ["PUR create/edit/action, สิทธิ์อนุมัติ และแบบพิมพ์ธนาคาร", "PUR create/edit/actions, approval permissions, and bank templates"],
  MEERP_DEP_RECEIVE_TRANSACTION: ["สัญญา receive-goods รายการ/Lot, กันซ้ำ และผลส่ง stock/จ่ายยา/บัญชี", "Line/Lot receipt contract, idempotency, and stock/dispensing/accounting results"],
  MEERP_DEP_ACC_TAX_RULES: ["ACC tax-rule API และนิยามฐาน/กฎธนาคาร", "ACC tax-rule API and bank-approved tax basis/rules"],
  MEERP_DEP_CONFIRMED_GR_SUMMARY: ["รายงานเฉพาะรายการ/Lot ที่ยืนยันแล้วและยอดแยกบริษัท/คลัง", "Summary of confirmed lines/Lots by vendor and storage"],
  MEERP_DEP_BANK_TAX_FORMULA: ["สูตรภาษีและยอดจ่ายที่ธนาคารรับรอง พร้อม ACC API", "Bank-approved tax/net-payment formula and ACC API"],
  MEERP_DEP_ACC_PAYMENT_PRINT: ["ACC payment/approval API และแบบรายงาน/เช็ค/ภาษี", "ACC payment/approval APIs and report/cheque/tax templates"],
  MEERP_DEP_ACC_JOURNAL_LEDGER: ["ACC journal/ledger API และคู่บัญชีที่รับรอง", "ACC journal/ledger APIs and approved postings"],
  MEERP_DEP_ACC_COA_MAPPING: ["ACC หัวบัญชีและ mapping API", "ACC chart-of-accounts and mapping APIs"],
  MEERP_DEP_TREATMENT_FEED: ["source ข้อมูลรักษา, mapping, สถานะนำส่งและผลตอบรับ ACC", "Treatment source, mappings, delivery status, and ACC acknowledgement"],
  MEERP_DEP_BANK_TEMPLATES: ["แบบฟอร์มธนาคาร เวอร์ชันเอกสาร และ API ประวัติการพิมพ์", "Bank templates, document versions, and print-history API"],

  MEERP_FLOW_SEARCH_MEDICINE: ["ค้นยา/ผู้ขาย", "Search medicine/vendor"],
  MEERP_FLOW_CHECK_PRICE_STOCK: ["ตรวจราคา จุดสั่งซื้อ และ Lot จาก stock เดิม", "Check prices, reorder point, and existing stock Lots"],
  MEERP_FLOW_OPEN_REQUEST: ["นำยาไปทำใบขอซื้อ", "Use medicine in a purchase request"],
  MEERP_FLOW_REQUEST_DRAFT: ["กรอกหัวเอกสารและรายการยา แล้วบันทึกร่าง", "Enter header and lines, then save draft"],
  MEERP_FLOW_REQUEST_APPROVAL: ["พิมพ์แบบขออนุมัติและส่งอนุมัติ", "Print request form and submit for approval"],
  MEERP_FLOW_CREATE_PO: ["สร้างและยืนยัน PO จากคำขอที่อนุมัติ", "Create and confirm PO from approved request"],
  MEERP_FLOW_PRINT_PO: ["ดูตัวอย่างและพิมพ์ PO ตามแบบธนาคาร", "Preview and print bank-form PO"],
  MEERP_FLOW_SELECT_PO: ["เลือก PO ที่พร้อมรับ", "Select a PO ready for receipt"],
  MEERP_FLOW_ENTER_LOTS: ["กรอกใบส่งของและยาแยก Lot", "Enter delivery note and medicine by Lot"],
  MEERP_FLOW_VERIFY_LINES: ["ตรวจและยืนยันแต่ละรายการยา", "Review and confirm each medicine line"],
  MEERP_FLOW_SYNC_DESTINATIONS: ["ติดตามผล stock, จ่ายยา และบัญชี", "Track stock, dispensing, and accounting results"],
  MEERP_FLOW_SET_SELLER_TYPE: ["เลือกประเภทผู้ขายและข้อยกเว้น", "Select seller type and exemption"],
  MEERP_FLOW_DEFINE_TAX_BASIS: ["ระบุฐานและช่วงมีผลตามกฎที่รับรอง", "Set approved tax basis and effective dates"],
  MEERP_FLOW_TEST_THRESHOLD: ["ทดสอบยอด 500.00/500.01", "Test 500.00/500.01 threshold"],
  MEERP_FLOW_ACTIVATE_RULE: ["ตรวจและเปิดใช้กฎ", "Review and activate rule"],
  MEERP_FLOW_CHOOSE_PERIOD: ["เลือกวัน/เดือน/ปี บริษัท และคลัง", "Choose day/month/year, vendor, and storage"],
  MEERP_FLOW_CHECK_CONFIRMED_GR: ["ตรวจ GR เฉพาะรายการ/Lot ที่ยืนยัน", "Check only confirmed GR lines/Lots"],
  MEERP_FLOW_SELECT_PAYABLE: ["เลือกรายการที่ยังไม่จัดจ่าย", "Select unpaid eligible lines"],
  MEERP_FLOW_REVIEW_PAYMENT: ["ตรวจยอดจ่ายและเอกสารต้นทาง", "Review payment total and source documents"],
  MEERP_FLOW_APPLY_TAX_RULE: ["ใช้กฎภาษีตามประเภทผู้ขาย", "Apply seller-type tax rule"],
  MEERP_FLOW_REVIEW_NET: ["ตรวจสูตรและยอดจ่ายสุทธิ", "Review formula and net payable"],
  MEERP_FLOW_CREATE_PAYMENT: ["สร้างชุดจ่าย", "Create payment batch"],
  MEERP_FLOW_SEND_APPROVAL: ["ส่งตรวจ/ส่งอนุมัติ", "Submit for review/approval"],
  MEERP_FLOW_APPROVE_PAYMENT: ["อนุมัติและบันทึกการจ่าย", "Approve and record payment"],
  MEERP_FLOW_PRINT_BANK_DOC: ["พิมพ์เอกสารธนาคารตามสถานะ", "Print bank documents at eligible status"],
  MEERP_FLOW_CHOOSE_TAX_PERIOD: ["เลือกงวดและชนิดภาษี", "Choose tax period and type"],
  MEERP_FLOW_REVIEW_TAX_SOURCE: ["ตรวจรายการภาษีและเอกสารต้นทาง", "Review tax entries and source documents"],
  MEERP_FLOW_REVIEW_TAX_TOTAL: ["ตรวจยอดและกันรายการซ้ำ", "Review total and prevent duplicate inclusion"],
  MEERP_FLOW_CREATE_TAX_REPORT: ["สร้างร่างรายงานจ่ายภาษี", "Create draft tax-payment report"],
  MEERP_FLOW_PRINT_TAX_REPORT: ["พิมพ์ตามขั้นอนุมัติที่รับรอง", "Print at the approved workflow stage"],
  MEERP_FLOW_CHOOSE_TRANSACTION: ["เลือกประเภทรายการบัญชี", "Select accounting transaction type"],
  MEERP_FLOW_ENTER_DEBIT_CREDIT: ["ระบุเดบิต/เครดิตและอ้างอิงต้นทาง", "Enter debit/credit and source reference"],
  MEERP_FLOW_CHECK_BALANCE: ["ตรวจสมดุล", "Check balance"],
  MEERP_FLOW_POST_LEDGER: ["ลงบัญชีและตรวจแยกประเภท", "Post and inspect ledger"],
  MEERP_FLOW_CHOOSE_ACCOUNT: ["เลือกหัวบัญชีและช่วงวัน", "Choose account and period"],
  MEERP_FLOW_REVIEW_LEDGER: ["ตรวจยอดยกมาและรายการเดบิต/เครดิต", "Review opening balance and debit/credit movements"],
  MEERP_FLOW_CREATE_ACCOUNT: ["เพิ่ม/แก้หัวบัญชี", "Create/edit account"],
  MEERP_FLOW_MAP_SOURCE: ["จับคู่ธุรกรรมต้นทางกับหัวบัญชี", "Map source transactions to accounts"],
  MEERP_FLOW_VALIDATE_MAPPING: ["ตรวจ mapping ที่ขาดหรือซ้อน", "Validate missing/conflicting mappings"],
  MEERP_FLOW_RECEIVE_TREATMENT: ["รับข้อมูลรักษาที่ final จากระบบเดิม", "Receive finalized treatment data"],
  MEERP_FLOW_SEND_ACCOUNTING: ["นำส่งสรุปตามหัวบัญชี", "Send summary by account"],
  MEERP_FLOW_CHECK_ACK: ["ตรวจผลตอบรับและส่งใหม่เฉพาะผิดพลาด", "Check acknowledgement and retry failures only"],
  MEERP_FLOW_FIND_DOCUMENT: ["ค้นเอกสารตามชนิด/งวด/เลขที่", "Find document by type/period/number"],
  MEERP_FLOW_CHECK_VERSION: ["ตรวจสถานะและเวอร์ชัน", "Check status and version"],
  MEERP_FLOW_PREVIEW_DOCUMENT: ["ดูตัวอย่างฉบับที่มีผล", "Preview effective version"],
  MEERP_FLOW_PRINT_DOCUMENT: ["พิมพ์หรือพิมพ์ใหม่พร้อมเก็บประวัติ", "Print or reprint with audit history"],

  MEERP_FIELD_DRUG_CODE: ["รหัสยา", "Medicine code"],
  MEERP_FIELD_DRUG_NAME: ["ชื่อยา", "Medicine name"],
  MEERP_FIELD_DRUG_TYPE: ["ประเภทยา", "Medicine type"],
  MEERP_FIELD_SIZE: ["ขนาด/รูปแบบ", "Size/form"],
  MEERP_FIELD_VENDOR_CODE: ["รหัสผู้ขาย", "Vendor code"],
  MEERP_FIELD_COST_PRICE: ["ราคาทุน", "Cost price"],
  MEERP_FIELD_SALE_PRICE: ["ราคาขาย", "Sale price"],
  MEERP_FIELD_REORDER_POINT: ["จุดสั่งซื้อ", "Reorder point"],
  MEERP_FIELD_STOCK_BALANCE: ["คงเหลือ", "Stock balance"],
  MEERP_FIELD_REQUESTER: ["ผู้ขอซื้อ", "Requester"],
  MEERP_FIELD_REQUIRED_DATE: ["วันที่ต้องการยา", "Required date"],
  MEERP_FIELD_DELIVERY_DATE: ["กำหนดส่ง", "Delivery date"],
  MEERP_FIELD_SUBTOTAL: ["ยอดก่อน VAT", "Subtotal before VAT"],
  MEERP_FIELD_VAT: ["VAT", "VAT"],
  MEERP_FIELD_DISCOUNT: ["ส่วนลด", "Discount"],
  MEERP_FIELD_PO_NUMBER: ["เลข PO", "PO number"],
  MEERP_FIELD_RECEIPT_DATE: ["วันที่รับยา", "Receipt date"],
  MEERP_FIELD_DELIVERY_NOTE: ["เลขใบส่งของ", "Delivery note number"],
  MEERP_FIELD_RECEIVED_BY: ["ผู้รับยา", "Received by"],
  MEERP_FIELD_STOCK_STATUS: ["ผลส่ง stock", "Stock result"],
  MEERP_FIELD_DISPENSE_STATUS: ["ผลส่งจ่ายยา", "Dispensing result"],
  MEERP_FIELD_ACCOUNTING_STATUS: ["ผลส่งบัญชี", "Accounting result"],
  MEERP_FIELD_PREVIOUSLY_RECEIVED: ["รับสะสม", "Previously received"],
  MEERP_FIELD_OUTSTANDING: ["ค้างรับ", "Outstanding"],
  MEERP_FIELD_VAT_TOTAL: ["รวม VAT", "Total incl. VAT"],
  MEERP_FIELD_SELLER_TYPE: ["ประเภทผู้ขาย", "Seller type"],
  MEERP_FIELD_TAX_KIND: ["ชนิดภาษี", "Tax type"],
  MEERP_FIELD_TAX_BASIS: ["ฐานคำนวณตามกฎธนาคาร", "Bank-rule tax basis"],
  MEERP_FIELD_THRESHOLD: ["เกณฑ์ยอด", "Amount threshold"],
  MEERP_FIELD_TAX_RATE: ["อัตราภาษี", "Tax rate"],
  MEERP_FIELD_EXEMPT: ["ยกเว้นภาษี", "Tax exempt"],
  MEERP_FIELD_EFFECTIVE_DATE: ["วันที่มีผล", "Effective date"],
  MEERP_FIELD_RULE_REFERENCE: ["เอกสารอ้างอิงกฎ", "Rule reference"],
  MEERP_FIELD_PERIOD: ["งวด/ช่วงวันที่", "Period/date range"],
  MEERP_FIELD_CONFIRMATION_REF: ["เลขอ้างอิงการยืนยัน", "Confirmation reference"],
  MEERP_FIELD_GR_NUMBER: ["เลข GR", "GR number"],
  MEERP_FIELD_CONFIRMED_QUANTITY: ["จำนวนยืนยัน", "Confirmed quantity"],
  MEERP_FIELD_PO_COUNT: ["จำนวน PO", "PO count"],
  MEERP_FIELD_GR_COUNT: ["จำนวน GR", "GR count"],
  MEERP_FIELD_THRESHOLD_BASIS: ["ฐานเทียบเกณฑ์ 500", "500 threshold basis"],
  MEERP_FIELD_WITHHOLDING: ["ภาษีหัก ณ ที่จ่าย", "Withholding tax"],
  MEERP_FIELD_ADJUSTMENT: ["รายการปรับปรุง", "Adjustment"],
  MEERP_FIELD_NET_PAYABLE: ["ยอดจ่ายสุทธิ", "Net payable"],
  MEERP_FIELD_PAYMENT_NO: ["เลขชุดจ่าย", "Payment batch number"],
  MEERP_FIELD_BANK_ACCOUNT: ["บัญชีรับเงินบริษัท", "Vendor bank account"],
  MEERP_FIELD_APPROVER: ["ผู้อนุมัติ", "Approver"],
  MEERP_FIELD_BANK_REF: ["เลขเช็ค/อ้างอิงธนาคาร", "Cheque/bank reference"],
  MEERP_FIELD_TAX_ENTRY: ["เลขรายการภาษี", "Tax entry number"],
  MEERP_FIELD_TAX_AMOUNT: ["จำนวนภาษี", "Tax amount"],
  MEERP_FIELD_DOCUMENT_REF: ["เลขเอกสารอ้างอิง", "Document reference"],
  MEERP_FIELD_ACCOUNTING_DATE: ["วันที่บัญชี", "Accounting date"],
  MEERP_FIELD_DOCUMENT_DATE: ["วันเอกสาร", "Document date"],
  MEERP_FIELD_TRANSACTION_TYPE: ["ประเภทรายการ", "Transaction type"],
  MEERP_FIELD_ACCOUNT_CODE: ["รหัสหัวบัญชี", "Account code"],
  MEERP_FIELD_ACCOUNT_NAME: ["ชื่อหัวบัญชี", "Account name"],
  MEERP_FIELD_DESCRIPTION: ["คำอธิบาย", "Description"],
  MEERP_FIELD_DEBIT: ["เดบิต", "Debit"],
  MEERP_FIELD_CREDIT: ["เครดิต", "Credit"],
  MEERP_FIELD_OPENING_BALANCE: ["ยอดยกมา", "Opening balance"],
  MEERP_FIELD_CLOSING_BALANCE: ["ยอดคงเหลือ", "Closing balance"],
  MEERP_FIELD_ACCOUNT_CATEGORY: ["หมวดบัญชี", "Account category"],
  MEERP_FIELD_PARENT_ACCOUNT: ["บัญชีแม่", "Parent account"],
  MEERP_FIELD_SOURCE_TYPE: ["ประเภทข้อมูลต้นทาง", "Source type"],
  MEERP_FIELD_COST_CENTER: ["ศูนย์ต้นทุน", "Cost center"],
  MEERP_FIELD_TREATMENT_DATE: ["วันที่รักษา", "Treatment date"],
  MEERP_FIELD_BATCH_NO: ["เลขชุดนำส่ง", "Delivery batch number"],
  MEERP_FIELD_SOURCE_COUNT: ["จำนวนรายการต้นทาง", "Source record count"],
  MEERP_FIELD_UNMAPPED_COUNT: ["รายการไม่มี mapping", "Unmapped records"],
  MEERP_FIELD_SENT_AT: ["เวลานำส่ง", "Sent at"],
  MEERP_FIELD_ACK_STATUS: ["ผลตอบรับบัญชี", "Accounting acknowledgement"],
  MEERP_FIELD_ERROR_REASON: ["เหตุผลผิดพลาด", "Error reason"],
  MEERP_FIELD_DOCUMENT_TYPE: ["ชนิดเอกสาร", "Document type"],
  MEERP_FIELD_VERSION: ["เวอร์ชัน", "Version"],
  MEERP_FIELD_CREATED_BY: ["ผู้สร้าง", "Created by"],
  MEERP_FIELD_PRINT_COUNT: ["จำนวนครั้งที่พิมพ์", "Print count"],
  MEERP_FIELD_TEMPLATE_VERSION: ["เวอร์ชันแบบฟอร์ม", "Template version"],

  MEERP_VARIANT_DAILY: ["รายวัน", "Daily"],
  MEERP_VARIANT_MONTHLY: ["รายเดือน", "Monthly"],
  MEERP_VARIANT_YEARLY: ["รายปี", "Yearly"],
  MEERP_VARIANT_COMPANY_PAYMENT: ["จ่ายบริษัท", "Vendor payments"],
  MEERP_VARIANT_TAX_PAYMENT: ["จ่ายภาษี", "Tax payments"],
  MEERP_VARIANT_JOURNAL: ["สมุดรายวัน", "Journal"],
  MEERP_VARIANT_LEDGER: ["บัญชีแยกประเภท", "Ledger"],
  MEERP_VARIANT_PUR_DOCUMENTS: ["จัดซื้อและรับยา", "Procurement and receiving"],
  MEERP_VARIANT_ACC_DOCUMENTS: ["บัญชีและการเงิน", "Accounting and finance"],
  MEERP_OPTION_COMPANY: ["บริษัท", "Company"],
  MEERP_OPTION_EXEMPT_COMPANY: ["บริษัทที่ได้รับยกเว้น", "Exempt company"],
  MEERP_OPTION_GOVERNMENT: ["หน่วยงานราชการ", "Government agency"],
  MEERP_OPTION_DRUG_DEPOSIT: ["ฝากเงินค่ายา", "Medicine revenue deposit"],
  MEERP_OPTION_DENTAL_DEPOSIT: ["ฝากเงินค่าทันตกรรม", "Dental revenue deposit"],
  MEERP_OPTION_TRANSFER: ["โอนเงิน", "Transfer"],
  MEERP_OPTION_YES: ["ใช่", "Yes"],
  MEERP_OPTION_NO: ["ไม่", "No"],
  MEERP_OPTION_REQUEST_FORM: ["แบบขออนุมัติซื้อ", "Purchase approval request"],
  MEERP_OPTION_PO: ["ใบสั่งซื้อ", "Purchase order"],
  MEERP_OPTION_RECEIPT: ["ใบรับยา", "Goods receipt"],
  MEERP_OPTION_VENDOR_SUMMARY: ["สรุปซื้อรายบริษัท", "Purchases by vendor"],
  MEERP_OPTION_PAYMENT_REPORT: ["รายงานอนุมัติจ่ายบริษัท", "Vendor payment approval report"],
  MEERP_OPTION_CHEQUE: ["เช็คธนาคารออมสิน", "GSB cheque"],
  MEERP_OPTION_WITHHOLDING: ["หนังสือหัก ณ ที่จ่าย", "Withholding certificate"],
  MEERP_OPTION_TAX_REPORT: ["รายงานอนุมัติจ่ายภาษี", "Tax payment approval report"],

  MEERP_ACTION_SEARCH: ["ค้นหา", "Search"],
  MEERP_ACTION_CREATE_REQUEST: ["สร้างใบขอซื้อ", "Create purchase request"],
  MEERP_ACTION_OPEN_STOCK: ["เปิดข้อมูลในระบบ stock", "Open existing stock"],
  MEERP_ACTION_PRICE_HISTORY: ["ประวัติราคา", "Price history"],
  MEERP_ACTION_CALCULATE_SALE_PRICE: ["คำนวณราคาขาย", "Calculate sale price"],
  MEERP_ACTION_CONFIRM_PRICE: ["ยืนยันราคา", "Confirm price"],
  MEERP_ACTION_ADD_MEDICINE: ["เพิ่มยา", "Add medicine"],
  MEERP_ACTION_SAVE_DRAFT: ["บันทึกร่าง", "Save draft"],
  MEERP_ACTION_PREVIEW_REQUEST: ["ดูตัวอย่างขออนุมัติ", "Preview approval request"],
  MEERP_ACTION_SUBMIT_APPROVAL: ["ส่งอนุมัติ", "Submit for approval"],
  MEERP_ACTION_APPROVE: ["อนุมัติ", "Approve"],
  MEERP_ACTION_CREATE_PO: ["สร้างใบสั่งซื้อ", "Create purchase order"],
  MEERP_ACTION_PREVIEW_PO: ["ดูตัวอย่าง PO", "Preview PO"],
  MEERP_ACTION_PRINT: ["พิมพ์", "Print"],
  MEERP_ACTION_ADD_LOT: ["เพิ่ม Lot", "Add Lot"],
  MEERP_ACTION_REVIEW: ["ตรวจทาน", "Review"],
  MEERP_ACTION_CONFIRM_LINE: ["ยืนยันรายการยา", "Confirm medicine line"],
  MEERP_ACTION_PREVIEW_RECEIPT: ["ดูตัวอย่างใบรับยา", "Preview receipt"],
  MEERP_ACTION_ADD_RULE: ["เพิ่มกฎ", "Add rule"],
  MEERP_ACTION_DELETE_DRAFT: ["ลบร่าง", "Delete draft"],
  MEERP_ACTION_TEST_CALCULATION: ["ลองคำนวณ", "Test calculation"],
  MEERP_ACTION_ACTIVATE: ["เปิดใช้กฎ", "Activate rule"],
  MEERP_ACTION_OPEN_DETAIL: ["เปิดรายละเอียด", "Open details"],
  MEERP_ACTION_REVIEW_PAYMENT: ["ตรวจยอดจ่าย", "Review payment"],
  MEERP_ACTION_SHOW_FORMULA: ["ดูวิธีคำนวณ", "Show formula"],
  MEERP_ACTION_RETURN_REVIEW: ["ส่งกลับตรวจ", "Return for review"],
  MEERP_ACTION_CREATE_PAYMENT: ["สร้างชุดจ่าย", "Create payment batch"],
  MEERP_ACTION_REVIEW_TOTAL: ["ตรวจยอด", "Review total"],
  MEERP_ACTION_SEND_APPROVAL: ["ส่งอนุมัติ", "Submit for approval"],
  MEERP_ACTION_APPROVE_PAYMENT: ["อนุมัติจ่าย", "Approve payment"],
  MEERP_ACTION_PRINT_APPROVAL: ["พิมพ์รายงานอนุมัติ", "Print approval report"],
  MEERP_ACTION_PRINT_CHEQUE: ["พิมพ์เช็คออมสิน", "Print GSB cheque"],
  MEERP_ACTION_PRINT_WITHHOLDING: ["พิมพ์หนังสือหัก ณ ที่จ่าย", "Print withholding certificate"],
  MEERP_ACTION_CREATE_TAX_REPORT: ["สร้างร่างรายงานภาษี", "Create draft tax report"],
  MEERP_ACTION_PREVIEW_TAX_REPORT: ["ดูตัวอย่างรายงานภาษี", "Preview tax report"],
  MEERP_ACTION_PRINT_FOR_APPROVAL: ["พิมพ์เพื่อเสนออนุมัติ", "Print for approval"],
  MEERP_ACTION_PRINT_APPROVED: ["พิมพ์ฉบับอนุมัติ", "Print approved version"],
  MEERP_ACTION_ADD_JOURNAL: ["บันทึกรายการ", "Add journal entry"],
  MEERP_ACTION_CHECK_BALANCE: ["ตรวจสมดุล", "Check balance"],
  MEERP_ACTION_POST: ["ลงบัญชี", "Post entry"],
  MEERP_ACTION_ADD_ACCOUNT: ["เพิ่มหัวบัญชี", "Add account"],
  MEERP_ACTION_EDIT: ["แก้ไข", "Edit"],
  MEERP_ACTION_DEACTIVATE: ["ปิดใช้", "Deactivate"],
  MEERP_ACTION_VALIDATE_MAPPING: ["ตรวจ mapping", "Validate mappings"],
  MEERP_ACTION_CHECK_DATA: ["ตรวจข้อมูล", "Check data"],
  MEERP_ACTION_OPEN_ERRORS: ["เปิดรายการผิดพลาด", "Open errors"],
  MEERP_ACTION_RECHECK: ["ตรวจใหม่", "Recheck"],
  MEERP_ACTION_RETRY_FAILED: ["ส่งใหม่เฉพาะผิดพลาด", "Retry failed only"],
  MEERP_ACTION_PREVIEW: ["ดูตัวอย่าง", "Preview"],
  MEERP_ACTION_REPRINT: ["พิมพ์ใหม่", "Reprint"],
};

const byLanguage = (index: 0 | 1): Record<string, string> =>
  Object.keys(copy).reduce<Record<string, string>>((messages, id) => {
    messages[id] = copy[id][index];
    return messages;
  }, {});

export const meerpScaffoldTH = byLanguage(0);
export const meerpScaffoldEN = byLanguage(1);
